// extracted by mini-css-extract-plugin
export var content = "background-box-section-module--content--i+CTx";
export var contentWrapper = "background-box-section-module--content-wrapper--iTLSH";
export var main = "background-box-section-module--main--s7Aqn";
export var topPadding = "background-box-section-module--top-padding--cveHR";